<template>
  <q-card class="col-12">
    <q-card-section>
      <span
        class="editor-content"
        v-html="targetInstructions"
      />
    </q-card-section>
  </q-card>
</template>
<script>
import DataCollection from 'src/mixins/DataCollection';

export default {

  name: 'InstructionsTarget',

  mixins: [DataCollection],

  // Even though this function doesn't emit 'record' it is required to be here
  // to make sure we break the emit-chain and don't emit 'record' from the
  // TargetData component.
  emits: ['record-program-data', 'record-target', 'record'],

  computed: {

    targetInstructions() {
      return this.target?.instructions || '';
    }, // targetInstructions()

  },
};
</script>
